import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w14ippdd",
  propsAsIs: false
});
export const ReviewSummaryLoading = () => {
  const {
    isMobile
  } = useDeviceLayout();
  if (isMobile) return <Stack space="s200">
        <SkeletonLoader height={28} width={28} marginTop={0} />
      </Stack>;
  return <Wrapper>
      <SkeletonLoader height={32} width={32} marginTop={0} />
      <SkeletonLoader height={32} width={78} marginTop={0} />
    </Wrapper>;
};

require("./ReviewSummaryLoading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewSummaryLoading.tsx");